import { Autocomplete, TextField } from '@mui/material';
import React, { useMemo } from 'react';
import { useCreditTypesList } from '../../../../hooks/requests/use-credit-types-list';

type CreditTypeOption = { value: string; label: string };

type Props = {
  value: string[];
  onChange: (creditTypeIds: string[]) => void;
  dataVy?: string;
};

export const CreditTypesMultiSelect: React.FC<Props> = ({ value, onChange, dataVy }) => {
  const { data, isLoading } = useCreditTypesList({ suspense: false });

  const options: CreditTypeOption[] = useMemo(
    () => (data?.creditTypes ?? []).map((creditType) => ({ value: creditType.id, label: creditType.name })),
    [data],
  );

  const selectedOptions: CreditTypeOption[] = useMemo(
    () =>
      value.reduce<CreditTypeOption[]>((matchedOptions, id) => {
        const match = options.find((option) => option.value === id);
        if (match) {
          matchedOptions.push(match);
        }
        return matchedOptions;
      }, []),
    [value, options],
  );

  return (
    <Autocomplete
      multiple
      fullWidth
      size="small"
      disableCloseOnSelect
      loading={isLoading}
      options={options}
      value={selectedOptions}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selected) => option.value === selected.value}
      onChange={(_event, newValue) => onChange(newValue.map((option) => option.value))}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Credits"
          placeholder={isLoading ? 'Loading credit types…' : 'Select credits'}
          data-vy={dataVy}
          slotProps={{
            ...params.slotProps,
            inputLabel: { shrink: true },
          }}
        />
      )}
    />
  );
};
